import { call, put, takeLatest } from "redux-saga/effects";
import {
  updateOrderGiftMessagesApi,
  updateOrderRecipientDetailsApi,
  updateOrderSenderDetailsApi,
} from "../../../api/myAccount";
import { requestToFetchMyOrders } from "../../slices/myAccount";
import {
  failedToUpdateGiftMessages,
  failedToUpdateRecipientDetails,
  failedToUpdateSenderDetails,
  requestToUpdateGiftMessages,
  requestToUpdateRecipientDetails,
  requestToUpdateSenderDetails,
  responseFromUpdateGiftMessages,
  responseFromUpdateRecipientDetails,
  responseFromUpdateSenderDetails,
} from "../../slices/orderModification";

/**
 * @param {object} response
 * @returns {boolean}
 */
function isOrderModificationSuccess(response) {
  return (
    response?.status === 200 ||
    response?.data?.status === 200 ||
    response?.isSuccess === true ||
    response?.data?.isSuccess === true
  );
}

/**
 * @param {{ payload?: { data?: Record<string, string>, subOrderId?: string } }} action
 */
function* updateSenderDetailsSaga(action) {
  try {
    const data = action.payload?.data ?? {};
    const res = yield call(updateOrderSenderDetailsApi, data);
    if (isOrderModificationSuccess(res)) {
      yield put(responseFromUpdateSenderDetails());
      yield put(requestToFetchMyOrders({ silent: true }));
    } else {
      yield put(failedToUpdateSenderDetails());
    }
  } catch {
    yield put(failedToUpdateSenderDetails());
  }
}

/**
 * @param {{ payload?: { data?: Record<string, string> } }} action
 */
function* updateRecipientDetailsSaga(action) {
  try {
    const data = action.payload?.data ?? {};
    const res = yield call(updateOrderRecipientDetailsApi, data);
    if (isOrderModificationSuccess(res)) {
      yield put(responseFromUpdateRecipientDetails());
      yield put(requestToFetchMyOrders({ silent: true }));
    } else {
      yield put(failedToUpdateRecipientDetails());
    }
  } catch {
    yield put(failedToUpdateRecipientDetails());
  }
}

/**
 * @param {{ payload?: { data?: Record<string, string> } }} action
 */
function* updateGiftMessagesSaga(action) {
  try {
    const data = action.payload?.data ?? {};
    const res = yield call(updateOrderGiftMessagesApi, data);
    if (isOrderModificationSuccess(res)) {
      yield put(responseFromUpdateGiftMessages());
      yield put(requestToFetchMyOrders({ silent: true }));
    } else {
      yield put(failedToUpdateGiftMessages());
    }
  } catch {
    yield put(failedToUpdateGiftMessages());
  }
}

/**
 * @generator
 */
export default function* watchOrderModificationSaga() {
  yield takeLatest(requestToUpdateSenderDetails.type, updateSenderDetailsSaga);
  yield takeLatest(requestToUpdateRecipientDetails.type, updateRecipientDetailsSaga);
  yield takeLatest(requestToUpdateGiftMessages.type, updateGiftMessagesSaga);
}
